import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { emptyUnseenNotificationCount } from './auth-slice';
import { RootState } from '../app/store';
import { setUserToLS } from '../helpers/localstorage-helper';

export const getNotifications = createAsyncThunk(
  'auth/getNotifications',
  async (_, { dispatch, getState }) => {
    const { data } = await axios.get(`/user/notification`);
    dispatch(emptyUnseenNotificationCount());

    const state = getState() as RootState;

    const user = { ...state.auth.userInfo, unseenNotificationCount: 0 };

    setUserToLS(user);

    return data.data.notifications as Notification[];
  }
);

export type Notification = {
  id: number;
  tag: number;
  type: number;
  isSeen: boolean;
  dateCreated: string;
  title: string;
  content: string;
  linkedUserId: number;
  earningType: number;
  userDirectBonusId: number;
  userTeamBonusId: number;
  userCustomerBonusId: number;
  userMatchingBonusId: number;
  promotionId: number;
  newsId: number;
  amount: number;
};

export interface notificationsSliceType {
  loading: boolean;
  notifications: Notification[];
}

const initialState = {
  loading: false,
  notifications: []
} as notificationsSliceType;

const notificationsSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getNotifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNotifications.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.notifications = payload;
    });
    builder.addCase(getNotifications.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default notificationsSlice.reducer;
